import React from 'react';
import { Languages } from 'lucide-react';
import { useLocale } from '../context/LocaleContext';

export const LanguageSelect = ({ id = 'language-select', compact = false, onChanged }) => {
  const { locale, changeLocale, t } = useLocale();
  return <label className={`language-select inline-flex items-center gap-2 text-sm min-w-0 ${compact ? '' : 'flex-wrap'}`} htmlFor={id}>
    <Languages size={16} aria-hidden="true" />{!compact && <span>{t('Language')}</span>}
    <select id={id} data-testid={id} aria-label={t('Language')} value={locale} onChange={e => { changeLocale(e.target.value); onChanged?.(e.target.value); }} className="rounded-md border border-slate-200 bg-white text-slate-800 py-2 pl-2 pr-6 text-sm max-w-full focus:ring-2 focus:ring-amber-400">
      <option value="en" lang="en" data-testid={`${id}-en`}>English</option><option value="so" lang="so" data-testid={`${id}-so`}>Soomaali</option><option value="de" lang="de" data-testid={`${id}-de`}>Deutsch</option>
    </select></label>;
};